import * as React from 'react';
import { useSelector } from 'react-redux';
import { Preloader } from '../../components/MarketPrice';
import { selectAllEstimation } from '../../selectors/estimation';
import { selectDealType, selectIsMyHome } from '../../selectors/page';

/**
 * Контейнер отвечает за рендер контента страницы оценки
 * (для поискуна и агента, все кроме готового отчета)
 *
 * Если страницы в состоянии загрузки и ранее небыло валидной оценки(нет данных по заданому адресу)
 *  - рендерим просто прелоадер
 * Если страница в состоянии загрузки и ранее была валидная оценка(смотрели страницу отчета)
 *  - показываем контент страницы с прелоадерами в полях оценки
 * Если у нас нет данных об оценки по заданному адресу и не ошибка загрузки
 *  - не рендерим контент страницы (остается только верхний блок фильтров и плашка "По такому адресу оценки нет")
 */
export const ValuationContentContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
  const estimation = useSelector(selectAllEstimation);
  const dealType = useSelector(selectDealType);
  const isMyHome = useSelector(selectIsMyHome);
  const { sale, rent } = estimation;
  const isLoading = estimation[dealType].isFetching;
  const isNotEstimationData = !estimation[dealType].data && !estimation[dealType].isError;

  if (isLoading && !sale.data && !rent.data) {
    return <Preloader />;
  }

  if (isLoading && (sale.data || rent.data)) {
    return <>{children}</>;
  }

  if (isNotEstimationData && !isMyHome) {
    return null;
  }

  return <>{children}</>;
};

ValuationContentContainer.displayName = 'ValuationContentContainer';
